import prop from 'lodash/fp/prop'
import toPairs from 'lodash/toPairs'
import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import { Observable } from 'rxjs/Observable'
import * as App from '../../app'
import { ApplicationState } from '../../rootReducer'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Types from './types'
import * as Utils from './utils'

const selectFormFields = (stateKey: string, state: ApplicationState) => {
  return prop('form.fields')(prop(stateKey)(state))
}

export type ValidationEpic =
  (
    action$: ReduxObservable.ActionsObservable<any>,
    store: Redux.Store<ApplicationState>,
  ) => Observable<Actions.ValidationAction>
export const validateForm: EpicCreator =
  (
    stateKey: string,
    constants: Actions.ConstantsMap,
    actions: Actions.ActionsMap<any>,
    validators: Types.FormValidators,
  ) =>
    (action$, store) =>
      action$.ofType(constants[Constants.UPDATE], constants[Constants.ENTER])
        .map(() => selectFormFields(stateKey, store.getState()))
        .map((fields) => toPairs(validators).map(([fieldName, validator]) => validator(fields[fieldName])))
        .map(Utils.isValid)
        .map(actions[Constants.VALIDATE])

type EpicCreator = (
  stateKey: string,
  constants: Actions.ConstantsMap,
  actions: Actions.ActionsMap<any>,
  validators: Types.FormValidators) => ValidationEpic
export const validateFormOnOpen: EpicCreator =
  (
    stateKey: string,
    constants: Actions.ConstantsMap,
    actions: Actions.ActionsMap<any>,
    validators: Types.FormValidators,
  ) =>
    (action$, store) =>
      action$.ofType(constants[Constants.ENTER])
        .map(() => selectFormFields(stateKey, store.getState()))
        .map((fields) => toPairs(validators).map(([fieldName, validator]) => validator(fields[fieldName])))
        .map(Utils.isValid)
        .map(actions[Constants.VALIDATE])

const resetFields: ReduxObservable.Epic<any, any> = (action$, store, {window}) =>
  action$
    .filter((action) => action.type.includes(Constants.RESET) && action.type.includes(Constants.NOUN))
    .filter((action) => Boolean(action.value))
    .filter((action) => Boolean(action.value.urlParam))
    .map(({value: fields}) => App.updateUrlParams(fields))

const updateFields: ReduxObservable.Epic<any, any> = (action$, store, {window}) =>
  action$
    .filter((action) => action.type.includes(Constants.UPDATE) && action.type.includes(Constants.NOUN))
    .filter((action) => Boolean(action.value))
    .filter((action) => Boolean(action.value.urlParam))
    .map((action) => App.updateUrlParams({[action.value.name]: action.value.value}))

export const epic = ReduxObservable.combineEpics(updateFields, resetFields)



// WEBPACK FOOTER //
// ./src/components/form/epic.ts